import CheckIfEmailUnique from "../account/CheckIfEmailUnique";

export default function ValidateEmail(Email, revEmailId, rfvEmailId, cvEmailId, PersonNumber) {
  if (!revEmailId) {
    revEmailId = "#revEmail";
  }
  if (!rfvEmailId) {
    rfvEmailId = "#rfvEmail";
  }
  var cvEmail;
  if (PersonNumber) {
    if (!cvEmailId) {
      cvEmailId = "#cvEmail";
    }
    cvEmail = Email.siblings(cvEmailId);
    cvEmail.hide();
  }

  var valid = true;
  var revEmail = Email.siblings(revEmailId);
  var rfvEmail = Email.siblings(rfvEmailId);

  revEmail.hide();
  rfvEmail.hide();

  Email.removeClass("error");
  if (Email.val().length == 0) {
    valid = false;
    rfvEmail.show();
    Email.addClass("error");
  }
  else {
    var regExpEmail = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,10})$/;
    if (!regExpEmail.test(Email.val())) {
      valid = false;
      revEmail.show();
      Email.addClass("error");
    }
    else {
      if (PersonNumber && !CheckIfEmailUnique(Email)) {
        valid = false;
        cvEmail.show();
        Email.addClass("error");
      }
    }
  }

  return valid;
}